export { useSearchResultsStore } from '@white-label-store/search-results';
export * from '@white-label-store/search-results';
